/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

export class EventStatus {
    static SCHEDULED = 0;
    static UPCOMING = 1;
    static LIVE = 2;
    static PAST = 3;
    static PROVISIONING = 4;
    static READY = 5;

    static toString(value) {
        switch (value) {
            case EventStatus.PAST:
                return "PAST"

            case EventStatus.SCHEDULED:
                return "SCHEDULED";

            case EventStatus.UPCOMING:
                return "UPCOMING";

            case EventStatus.LIVE:
                return "LIVE";

            case EventStatus.PROVISIONING:
                return "PROVISIONING";

            case EventStatus.READY:
                return "READY";

            default:
                return null;
        }
    }
}
